<template>
  <!-- 曲线对比 -->
  <div class="curveWrapper main">
    <div class="head" style="margin-bottom:0.24rem">
      <!-- 搜索区域 -->
      <div class="searchArea">
          <div class="title">查询筛选</div>
          <div class="content">
              <el-form style="width: 90%"  label-width="90px">
                  <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="选择设备：">
                              <el-select v-model="quantitySelected" placeholder="请选择" size="small" @click.native="selectDevice">
                                  <el-option label="" value=""></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="选污染物：">
                              <el-select v-model="searchParam.wryName" placeholder="请选择" size="small" @change="searchChange($event,'wry')">
                                  <el-option v-for="(item,index) in DeviceParamsSD"
                                   :label="item.name"
                                   :value="item.name"
                                   :key="index"></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                         <el-form-item label="国控站点：">
                              <el-select v-model="kgzd" placeholder="请选择" size="small" @change="searchChange($event,'kqz')">
                                  <el-option v-for="(item,index) in AreaList"
                                   :label="item.name"
                                   :value="item.code"
                                   :key="index"></el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">
                      <el-col :span="12">
                          <el-form-item label="时间区间：">
                          <el-select v-model="searchParam.timeLxName" placeholder="请选择" size="small"
                          @change="searchChange($event,'timeLx')">
                              <el-option v-for="(item,index) in timeList"
                                   :label="item.label"
                                   :value="item.value"
                                   :key="index"></el-option>
                          </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item label="选择日期：">
                          <el-date-picker
                              v-model="dateRange"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              size="small"
                              :picker-options="pickerOptions"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              @change="changeDate">
                          </el-date-picker>
                          </el-form-item>
                      </el-col>
                  </el-row>
              </el-form>
              <div class="block"></div>
              <div class="rightBtn">
                  <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="searchBtnClick">查询</el-button>
                  <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;"  @click="resetting">重置</el-button>
              </div>
          </div>
      </div>
    </div>
    <!-- 图表 -->
    <section class="section">
      <div class="sectionSearch">
        <div class="title">曲线对比</div>
        <!-- <div class="mark">*CO浓度单位为mg/m³ 其他颗粒物浓度单位为μg/m³ ，温度单位为°C，湿度单位为%，气压单位为hpa，风速单位为m/s，风向单位为°</div> -->
      </div>
      <!-- 折线图 -->
      <CompareLine ref='CompareLine'
                   :ajaxParam="ajaxParam"
                   :scrollTop="scrollTop" />
    </section>
  </div>
</template>

<script>
import Com from '../.././common/js/com.js'
import CompareLine from '@/components/dataCompare/children/compareLine.vue'
export default {
  props:['paramsObject'],
  inheritAttrs: false,
  components: {
    CompareLine,
  },
  data () {
    return {
      searchParam: {  // 页面搜索数据
        timeLx: '',
        timeLxName: '',
        wry: '',
        wryName: '',
        kqz: '',
        start: '',
        end: '',
        code: [],
        category: [],
        Eparam: '',
        gkzArr: []
      },
      quantitySelected:'', // 已选设备数量
      AreaList:[], // 国控站点列表
      kgzd:'', // 国控站点
      dateRange:[], // 日期范围
      timeList: [],
      ajaxParam: {}, /* 折线图数据入参 */
      selectedRows: [], /* selectedRows: 表格选中数据 */
      scrollTop: 0,
      pickerOptions:{  // 只能选择今天以及今天之前的日期
        disabledDate(date) {
          return date.getTime()> Date.now();
        }
      }
    }
  },
  created () {
    this.$bus.$on('setal', (data) => {
      this.AreaList = data
      let firstgkz = data[0]
      this.kgzd = firstgkz.code
      this.searchParam.gkzArr = [{ code: firstgkz.code, category: firstgkz.name, gkz: firstgkz.gkz }]
    })
    const menu1Search = window.sessionStorage.getItem('menu1Search')  // 曲线对比缓存
    // console.log(menu1Search, '---------->曲线对比缓存')
    if (menu1Search) {
      const menu1SearchObj = JSON.parse(menu1Search)
      this.timeList = Com.timeList
      this.searchParam.timeLx = menu1SearchObj.timeLx
      this.searchParam.timeLxName = menu1SearchObj.timeLxName
      this.searchParam.kqz = menu1SearchObj.kqz
      this.searchParam.start = menu1SearchObj.start
      this.searchParam.end = menu1SearchObj.end
      this.searchParam.wry = menu1SearchObj.wry
      this.searchParam.wryName = menu1SearchObj.wryName
      this.searchParam.Eparam = menu1SearchObj.Eparam
      this.searchParam.gkzArr = menu1SearchObj.gkzArr
      this.dateRange.push(menu1SearchObj.start)
      this.dateRange.push(menu1SearchObj.end)
    } else {
      this.timeList = Com.timeList
      this.searchParam.timeLx = Com.timeDefault
      this.searchParam.timeLxName = Com.timeDefaultName
      var start = Com.getBeforeDate(7, 'date')
      var end = Com.getBeforeDate(0, 'date')
      this.searchParam.start = start
      this.searchParam.end = end
      this.dateRange.push(start)
      this.dateRange.push(end)
    }
  },
  mounted () {
    document.getElementById('bodyWrapperId').addEventListener('scroll', () => {
      const top = document.getElementById('bodyWrapperId').scrollTop
      this.scrollTop = top
    })
  },
  methods: {
    selectDevice() { // 选择设备
      this.$emit('isShow',true)
    },
    searchBtnClick() { // 查询
      const num = Com.dateDiff(this.searchParam.start, this.searchParam.end)
      if (this.searchParam.timeLx === 'D') {
        if (num < 2) {
          this.$message.warning('时间类型为天时,请间隔2天以上')
        } else if (num > 366) {
          this.$message.warning('最多只可以选择一年！')
        } else {
          this.searchUrlClick()
        }
      } else {
        if (num > 366) {
          this.$message.warning('最多只可以选择一年！')
        } else {
          this.searchUrlClick()
        }
      }
    },
    searchUrlClick() {
      this.ajaxParam = {
        timeLx: this.searchParam.timeLx,
        timeLxName: this.searchParam.timeLxName,
        wry: this.searchParam.wry,
        wryName: this.searchParam.wryName,
        kqz: this.searchParam.kqz,
        start: this.searchParam.start,
        end: this.searchParam.end,
        code: this.searchParam.code,
        category: this.searchParam.category,
        Eparam: this.searchParam.Eparam,
        gkzArr: this.searchParam.gkzArr
      }
      this.filterFun() // 过滤数据
      // console.log(JSON.stringify(this.ajaxParam), '----------menu1Search查询')
      window.sessionStorage.setItem('menu1Search', JSON.stringify(this.ajaxParam))
      this.$refs.CompareLine.initChart(this.ajaxParam, this.scrollTop)
    },
    filterFun: function () { // 过滤数据
      // 修改时间格式
      const idx = this.ajaxParam.start.indexOf(' ')
      if (idx !== -1) { // 年月日时分秒
        if (this.ajaxParam.timeLx === 'D') {
          this.ajaxParam.start = (this.ajaxParam.start).substring(0, idx)
          this.ajaxParam.end = (this.ajaxParam.end).substring(0, idx)
        }
      } else { // 年月日
        if (this.ajaxParam.timeLx === 'H') {
          const startTime = Com.stringTime((new Date()), 'time')
          const endTime = Com.stringTime((new Date()), 'lastHour')  //获取当前时间的前一个小时（修改原因是当前的一个小时无数据）
          this.ajaxParam.start = (this.ajaxParam.start) + startTime
          this.ajaxParam.end = (this.ajaxParam.end) + endTime
        }
      }

      // 根据搜索条件过滤数据
      if (this.selectedRows.length > 0) {
        const code = []
        const category = []
        this.selectedRows.forEach((item, i) => {
          code.push(item.code)
          category.push(item.name)
        })
        if (this.ajaxParam.gkzArr.length > 0) {
          code.push(this.ajaxParam.gkzArr[0].code)
          category.push(this.ajaxParam.gkzArr[0].category)
        }
        this.ajaxParam.code = code.join(',')
        this.ajaxParam.category = code
      }
    },
    // 切换搜索值
    searchChange(val,type) {
      if(type == 'wry') {
        this.searchParam.wryName = val;
        this.searchParam[type] = val
        this.searchParam.Eparam = val
      } else if( type == 'kqz') {
         var objVal = {}
         this.AreaList.forEach(item=> {
          if(item.code === val) {
            objVal = item
          }
         })
         this.searchParam[type] = objVal.name
         this.searchParam.gkzArr = [{ code: val, category: objVal.name, gkz: objVal.gkz }]
      } else if ( type == 'timeLx') {
        if(val == '时均值') {
          this.searchParam.timeLxName = val
          this.searchParam[type] = 'H'
        } else if(val == '日均值') {
          this.searchParam.timeLxName = val
          this.searchParam[type] = 'D'
        }
      }
    },
    // 切换日期范围
    changeDate(dateString) {
      const num = this.dateDiff(dateString[0], dateString[1])
      if(num > 366) {
        this.$message.warning('最多只可以选择一年！')
      } else {
        this.searchParam.start = dateString[0]
        this.searchParam.end = dateString[1]
      }
    },
    selectChange(val) {
      this.selectedRows =val;
      this.quantitySelected = '已选择'+ val.length + '台设备'
      this.searchBtnClick();
    },
    // 重置
    resetting() {
      this.searchParam.timeLx = 'H',
      this.searchParam.timeLxName = '时均值',
      this.searchBtnClick()
    },
  },
  watch: {
    paramsObject: {
      handler: function (value) {
        const that = this
        if(value) {
          this.quantitySelected = '已选择'+ value.length + '台设备'
          const result = JSON.parse(JSON.stringify(value))
          this.selectedRows = result
          setTimeout(function () {
            that.searchBtnClick() // 查询
          }, 200)
        }
      },
      deep: true
    },
    DeviceParamsSD: {
      handler: function (result) {
        this.searchParam.wryName = result[0].name
        this.searchParam.wry = result[0].name
        this.searchParam.Eparam = result[0].name
      },
      deep: true
    },
    AreaList: {
      handler: function (result) {
        this.searchParam.kqz = result[0].name
      },
      deep: true
    },
  },
  computed: {
    DeviceParamsSD: function () {
      return this.$store.state.moduleSD.DeviceParamsSD
    },
  }
}
</script>

<style lang="less" scoped>
.curveWrapper {
  height: calc(100% - 0.64rem);
  display: flex;
  flex-direction: column;
}
.section {
  padding: 0.24rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  .sectionSearch {
    display: flex;
    .title {
      font-size: 0.16rem;
      color:#405891;
      font-weight: bold;
    }
    .mark {
      padding-left: 10px;
      font-size: 8px;
      color: #ccc;
      font-weight: bold;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0.1rem;
  .el-form-item__label {
      color: #405891;
  }
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-range-editor--small.el-input__inner {
  width: 100%;
}
</style>
